export default class StatService {

    constructor(apiUrl = "https://api.iot.freeutg.com") {
        this.apiUrl = apiUrl;
    }

    async getDeviceStat(devEUI, start = "", stop = "") {
        const response = await fetch(this.apiUrl + "/air_quality/" + devEUI + "?from=" + stop + "&to=" + start);
        return await response.json();
    }


}